import {instance} from "./instance";

// After signing in with Firebase: creates the Soulify profile (and Stripe customer) on first sign-in
export const auth_session = (data: { name?: string } = {}) => {
    return instance.post('/auth/session', data);
}

// Deletes the subscription, all chats and the profile; the app then deletes the Firebase login
export const auth_delete_account = () => {
    return instance.delete('/auth/account');
}

export const auth_get_profile = () => {
    return instance.post('/auth/user');
}
